import React from 'react';
import './Avatar.css';
import Storage from '../Storage/Storage';

const storageMap = new Map(Storage);
const Avatar = function (props) {
  const { gender, photoURL, alt } = props;
  let image = storageMap.get('user');
  if (gender) {
    image = gender === 'male' ? storageMap.get('male') : storageMap.get('female');
  }
  if (photoURL) {
    image = photoURL;
  }

  return (<img
    className="avatar"
    alt={alt}
    src={image}
  />);
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Avatar/index.js